import scrollToElement from "./scrollto";
document.querySelectorAll('.link--scroll-to').forEach((el) => {
    el.addEventListener('click', (event) => {
        scrollToElement(document.querySelector(el.hash));
        event.preventDefault();
        setTimeout(() => document.location.hash = el.hash, 1000);
    });
});
